import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import { NODE_TYPES } from '../Node/config';
import './style.css';
import { MAX_LENGTH as maxLength } from './config';

const NodeTypeSelect = props => {

    const labels = useMemo( () => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    id = crypto.randomUUID();

    /**
     * @name onChange
     * @function
     * @description Sends the value back to the parent component
     * @param {EventListenerObject} e 
     */
    const onChange = e => {
        props.onChange( 'name', e.target.value );
    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale );
    }, [ labels, locale ]);

    return (
        <FormControl fullWidth className="coe__nodeName">
            <TextField
                id={ id }
                defaultValue={ props.defaultValue }
                label={ labels.nodeName }
                inputProps={{ maxLength }}
                required
                onChange={ onChange } />
        </FormControl>
    )
}

NodeTypeSelect.defaultProps = {
    onChange: () => {}
}

NodeTypeSelect.propTypes = {
    defaultValue: PropTypes.oneOf( NODE_TYPES ),
    onChange: PropTypes.func
}

export default NodeTypeSelect;